import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getScoreColor(score: number): string {
  if (score >= 90) return 'text-green-500';
  if (score >= 50) return 'text-orange-500';
  return 'text-red-500';
}

export function getScoreBgColor(score: number): string {
  if (score >= 90) return 'bg-green-500';
  if (score >= 50) return 'bg-orange-500';
  return 'bg-red-500';
}

export function getScoreLabel(score: number): string {
  if (score >= 90) return 'Good';
  if (score >= 50) return 'Needs Improvement';
  return 'Poor';
}

export function getRatingColor(rating: 'good' | 'needs-improvement' | 'poor'): string {
  switch (rating) {
    case 'good':
      return 'text-green-500';
    case 'needs-improvement':
      return 'text-orange-500';
    case 'poor':
      return 'text-red-500';
  }
}

export function formatMetricValue(value: number, unit: string): string {
  if (unit === 's') {
    return `${value.toFixed(2)}s`;
  }
  if (unit === 'ms') {
    return `${Math.round(value)}ms`;
  }
  if (unit === '') {
    return value.toFixed(3);
  }
  return `${value}${unit}`;
}
